import * as z from "zod";

/**
 * Region-filtered inventory for a variant, computed server-side from the
 * customer's fulfillment region. When present, the client overlays these onto
 * the draft-return variant snapshot so stock reflects only the customer's
 * region — mirroring how the advanced exchange path returns region-correct
 * ProductData.
 */
export const AdjustedVariantInventorySchema = z.object({
  variantId: z.string(),
  inventoryQuantity: z.number(),
});
export type AdjustedVariantInventory = z.infer<
  typeof AdjustedVariantInventorySchema
>;

export const VariantExchangeRecommendationsSchema = z.object({
  recommendedOptions: z.array(
    z.object({ name: z.string(), values: z.array(z.string()) }),
  ),
  recommendationTitle: z.string().optional(),
  recommendationSubtitle: z.string().optional(),
  outOfStockApology: z.string().optional(),
  /**
   * Present only when fulfillment region filtering applied. One entry per
   * variant of the returned product, carrying the region-filtered available
   * quantity. Absent means no filtering — use the snapshot's stock as-is.
   */
  adjustedVariants: z.array(AdjustedVariantInventorySchema).optional(),
});
export type VariantExchangeRecommendations = z.infer<
  typeof VariantExchangeRecommendationsSchema
>;
